import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the PlaceAddressPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'placeAddress',
})
export class PlaceAddressPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(place) {
    const a = place.address || '',
      c = place.city || '',
      s = place.state || '',
      z = place.zipcode || '';

    if (c && s) {
      return `${a} ${c}, ${s} ${z}`;
    } else {
      return `${a} ${c} ${s} ${z}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/place-address/place-address.ts